import { TFunction } from 'i18next';
import { IBenefit } from '@/widgets/BenefitsBlock';
import dashboardImg from 'public/product-reviews/dashboard.webp';
import feedbackImg from 'public/product-reviews/feedback.webp';
import graphicsImg from 'public/product-reviews/graphics.webp';
import reviewsImg from 'public/product-reviews/reviews.webp';
import surveyTemplateImg from 'public/product-reviews/survey-template.webp';

const images = [dashboardImg, feedbackImg, graphicsImg, surveyTemplateImg, reviewsImg];

export const getReviewsBenefits = (t: TFunction): IBenefit[] => {
  const benefits = t('productPages.reviews.benefits', { returnObjects: true }) as Array<{
    heading: string;
    description: string;
  }>;

  return benefits.map((benefit, index) => ({
    ...benefit,
    image: images[index]!,
  }));
};
